import React, {useState} from "react";
import {MoreLessToggleIcon} from "../../custom/MoreLessToggleIcon";
import {ColoredIcon} from "../../Steps/step-parts-components/SportIconAndTitle";
import { LevelProps } from '../types';
import { ToggleSportProps } from '../TreeSport';


export const ResultTreeSport: React.FC<LevelProps & ToggleSportProps> = ({id, tree, toggleSport}) => {

    const sport = tree.s[id];
    const [expandSports, setExpandSports] = useState(true);

    function toggleExpandSports() {
        setExpandSports(prevState => !prevState);
        toggleSport(id);
    }
    const sportColor = sport.sc;

    return (
        <>
            <div className="mb-[10px]">
                <div className="mb-0">
                    <div className="text-[14px] desktop:text-[20px] font-normal">
                        <div className="rounded-[8px] flex items-center bg-[#171A1E]">
                            <div className="flex items-center p-[7px] tablet:p-[16px]">
                                <div className="flex justify-center items-center">
                                    <ColoredIcon color={sport.sc} imageUrl={sport.siu}/>
                                </div>
                                <div className="flex justify-center items-center text-center px-[22px]">
                                    {sport.sn}
                                </div>

                                <div className="opacity-60">{sport.c}</div>
                            </div>
                            <div onClick={toggleExpandSports} className="ml-auto mr-[5px] w-[29px]">
                                <MoreLessToggleIcon isOpen={expandSports} doubleArrow color={sport.sc}/>
                            </div>
                        </div>
                    </div>
                    <hr style={{border: sportColor}} className={`border-b m-0 tablet:hidden`}/>
                </div>

            </div>
        </>
    )
}
